import { AxiosError, AxiosResponse } from 'axios';

import { useQuery } from '@pricemoov-oss/moon';

const FEATURE_FLAG_QUERY_ID = 'feature-flags';

export type DynamicPricingSettingsFeatureFlagValue = {
    activate_corridors: boolean;
    activate_guidelines: boolean;
    activate_indexations: boolean;
    activate_rounding_rules: boolean;
    allow_bulk_actions_on_indexed_price_line: boolean;
};

export interface FeatureFlag<Value = any> {
    created_at: Date;
    description: string;
    enabled: boolean;
    name: string;
    updated_at: Date;
    value?: Value;
}

type FeatureFlagQueryData = Array<FeatureFlag>;

export type FeatureFlagRegistry = Record<string, FeatureFlag>;

function featureFlagsQueryDataDeserializer(
    queryData: AxiosResponse<FeatureFlagQueryData> | undefined
): FeatureFlagRegistry {
    return queryData?.data?.reduce(
        (accumulator, value) => ({ ...accumulator, [value.name]: value }),
        {}
    );
}

function useFeatureFlagsQuery(enabled: boolean) {
    return useQuery<never, AxiosResponse<FeatureFlagQueryData>, FeatureFlagRegistry, AxiosError>({
        source: 'rest',
        id: FEATURE_FLAG_QUERY_ID,
        endPoint: `config/feature-flags/`,
        queryConfig: {
            select: featureFlagsQueryDataDeserializer,
            enabled,
        },
    });
}

export default useFeatureFlagsQuery;
